import H from '@here/maps-api-for-javascript';
import returnLocationSvgUrl from 'global/img/return-location-marker.svg';
import { createDepotSvg } from 'icons/marker';
import {
  filterDepot,
  isActivityToDisplay,
  isRouteToDisplay,
  isPointDepot,
} from 'utils/map/MapFeatureFilters';

const MARKER_ANCHOR = { x: 17, y: 48 };
const MARKER_SIZE = { w: 34, h: 48 };

export function getStartEndFeatures(geoJSON, display, isSolution) {
  if (!geoJSON?.geo?.features) return [];

  const depotFeatures = filterDepot(geoJSON, true);
  const filtered = isSolution
    ? depotFeatures.filter((f) => !isActivityToDisplay(f) && isRouteToDisplay(f, display))
    : depotFeatures.filter((f) => !isActivityToDisplay(f));

  if (filtered.length <= 1) return filtered;

  if (
    filtered[0].geometry.coordinates[0] === filtered[1].geometry.coordinates[0] &&
    filtered[0].geometry.coordinates[1] === filtered[1].geometry.coordinates[1]
  ) {
    return [filtered.find(isPointDepot) || filtered[0]];
  }

  return filtered;
}

function createStartEndMarker(feature, id) {
  const coords = feature.geometry.coordinates;
  const depot = isPointDepot(feature);
  const iconContent = depot ? createDepotSvg(false) : returnLocationSvgUrl;
  const icon = new H.map.Icon(iconContent, { anchor: MARKER_ANCHOR, size: MARKER_SIZE });
  const marker = new H.map.Marker({ lat: coords[1], lng: coords[0] }, { icon, volatility: true });
  marker.setData({ ...feature.properties, markerId: id });
  return marker;
}

export function updateStartEndGroupMarkers(features, group, translationsRef, map, attachHoverEventsFn) {
  const newMarkerIds = new Set();
  const existingMarkerIds = new Set();

  group.getObjects().forEach((marker) => {
    existingMarkerIds.add(marker.getData()?.markerId);
  });

  features.forEach((feature) => {
    const coords = feature.geometry.coordinates;
    const props = feature.properties || {};
    const prefix = isPointDepot(feature) ? 'depot' : 'return';
    const id = props.id || `${prefix}_${coords[0]}_${coords[1]}`;
    newMarkerIds.add(id);

    if (!existingMarkerIds.has(id)) {
      const marker = createStartEndMarker(feature, id);
      attachHoverEventsFn(marker, translationsRef, map);
      group.addObject(marker);
    }
  });

  [...group.getObjects()].forEach((marker) => {
    if (!newMarkerIds.has(marker.getData()?.markerId)) {
      group.removeObject(marker);
    }
  });

  group.setVisibility(true);
}
